import React, { useState, useEffect } from 'react'
import { getData, postData, putData } from '../../actions/servicesHttp'
import Button from 'react-bootstrap/Button'
import DataTableDemo from '../../components/generals/datatables/datatable'
import Header from '../../components/generals/header'
import styles from '../../css/geofences/Geofences.module.css'
import stylesIndex from './../../css/Index.module.css'
import iconMarker from '../../img/icon_geofence.svg'
import { formatDate } from '../../components/generals/charts/utils/DatesFormats'
import ModalFence from '../../components/modals/modalsGeofences/modalFence'
import ModalInformationFence from '../../components/modals/modalsGeofences/modalInformationFence'
import $ from 'jquery'
import Swal from 'sweetalert2'
import store from '../../reducer/store'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Loading from '../../components/generals/loading'

export default function Geofences () {
  const { t } = useTranslation('geofences')
  const navigate = useNavigate()
  const { user } = store.getState()
  const role = user.roles
  const [fences, setFences] = useState(null)
  const [fence, setFence] = useState(null)
  const [unitArea, setUnitArea] = useState('m')
  const [modals, setModals] = useState({
    create: false,
    edit: false,
    information: false
  })

  useEffect(() => {
    getGeofence()
  }, [])

  //* efecto de formateo de fecha de la fecha de creación
  useEffect(() => {
    if (fences) {
      const data = fences
      data.forEach((element) => {
        element.date_order = formatDate(element.date_order)
      })
      setFences(data)
    }
  }, [fences])

  const getGeofence = async () => {
    const response = await getData('geofences', undefined, navigate)
    if (response?.status === 200) {
      setFences(response.data)
    } else {
      setFences([])
    }
  }

  const nameFenceValidation = (name, id = null) => {
    let result = false
    if (name === '' || name === null) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: t('message1'),
        showConfirmButton: false,
        timer: 2500
      })
    } else {
      let condition
      if (id) condition = (fence) => (fence.name === name.trim()) && (fence.id !== id)
      else condition = (fence) => fence.name === name.trim()
      if (fences?.some(condition)) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: t('message2'),
          showConfirmButton: false,
          timer: 2500
        })
      } else {
        result = true
      }
    }
    return result
  }

  function validationsForms (type) {
    let inputAdress
    let inputDescription
    let response = true
    const messageRequire = t('message3')
    const messageRequireHeightStreet = t('message4')

    if (type === 'add') {
      inputAdress = document.querySelector('#place')
      inputDescription = document.querySelector('#description')
    } else {
      inputAdress = document.querySelector('#editPlace')
      inputDescription = document.querySelector('#editDescription')
    }

    if (inputAdress.value === undefined || inputAdress.value === null || inputAdress.value === '') {
      $('#place').addClass('error')
      $('#placeError').text(messageRequire)
      $('#placeError').addClass('visible')
      response = false
    } else {
      let flag = false
      try {
        // const input = inputAdress.value
        // console.log(input)
        let prueba = inputAdress.value.split('Argentina')
        prueba = prueba[0].split(',')

        prueba.pop()
        prueba.pop()
        for (let index = 0; index < 2; index++) {
          for (let i = 0; i < 10; i++) {
          // console.log(i, prueba[index], prueba[index].includes(i))
            if (prueba[index].includes(i)) {
              if (!prueba[index].includes('Comuna')) {
                flag = true
                break
              }
            }
          }
        }
      } catch (error) {
        flag = false
      }
      if (!flag) {
        if (type === 'add') {
          $('#place').addClass('error')
          $('#placeError').text(messageRequireHeightStreet)
          $('#placeError').addClass('visible')
          response = false
        } else {
          $('#editPlace').addClass('error')
          $('#editPlaceError').text(messageRequireHeightStreet)
          $('#editPlaceError').addClass('visible')
          response = false
        }
      } else {
        if (type === 'add') {
          $('#place').removeClass('error')
          $('#placeError').text('')
          $('#placeError').removeClass('visible')
        } else {
          $('#editPlace').removeClass('error')
          $('#editPlaceError').text('')
          $('#editPlaceError').removeClass('visible')
        }
      }
    }

    if (inputDescription.value === undefined || inputDescription.value === null || inputDescription.value === '') {
      $('#description').addClass('error')
      $('#descriptionError').text(messageRequire)
      $('#descriptionError').addClass('visible')
      response = false
    } else {
      $('#description').removeClass('error')
      $('#descriptionError').text('')
      $('#descriptionError').removeClass('visible')
    }

    return response
  };

  const saveFence = async (info, type, id = null, unitArea) => {
    $('#btnModalFence').prop('disabled', true)
    // console.log("data para crear la geocerca:", info);
    const name = info.name
    let area = info.area
    area = unitArea === 'km' ? parseInt(info.area) * 1000 : parseInt(info.area)

    const json = {
      name,
      description: info.description,
      lat: info.lat,
      lon: info.lon,
      place: info.place,
      area,
      color_range: info.color_range
    }

    if (nameFenceValidation(name, id) && validationsForms(type)) {
      let data
      let succcessTitle
      let errorTitle
      if (type === 'add') {
        succcessTitle = t('message5')
        errorTitle = t('error1')
        data = await postData('geofences', json, navigate)
      } else {
        if (id) json.id = id
        succcessTitle = t('message6')
        errorTitle = t('error2')
        data = await putData('geofences', json, navigate)
      }

      if (data.data.result) {
        if (type === 'add') {
          setModals({
            ...modals,
            create: false
          })
        } else {
          setModals({
            ...modals,
            edit: false
          })
        }
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: succcessTitle,
          showConfirmButton: false,
          timer: 1500
        })
        getGeofence()
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: errorTitle,
          showConfirmButton: false,
          timer: 2500
        })
      }
    }

    setUnitArea('m')
    setTimeout(() => {
      $('#btnModalFence').prop('disabled', false)
    }, 1500)
  }

  const showModal = (type) => {
    setModals({
      ...modals,
      [type]: true
    })
  }

  const closeModal = (type) => {
    setModals({
      ...modals,
      [type]: false
    })
    setUnitArea('m')
  }

  const getFence = (data) => {
    const fence = fences.filter((fence) => fence.id === data)
    setFence(fence[0])
  }

  return (
  <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
    <div className={`content  ${stylesIndex.mainContent}`}>
        <Header title={t('title')} />
        <section className={styles.containerToggle}>
        {role?.geofencesPage.newGeocerca && <Button
            className={styles.btnDark}
            onClick={() => showModal('create')}
            variant="dark"
            style={{ marginLeft: '1rem' }}
          >
            <img
              src={iconMarker}
              alt="map-marker"
              style={{ marginRight: '0.5rem', width: '1.5rem' }}
            />
            {t('label1')}
          </Button>}
        </section>
        <section>
          <div>
            {fences === null && <Loading color="primary" />}
            {fences !== null && <DataTableDemo
              data={fences}
              table="geofences"
              // onSelecteds={handleChange}
              reload={getGeofence}
              rowStates={false}
              rowSelecteds={false}
              editUsers={false}
              actionDashboard={false}
              optionsMenu={role?.geofencesPage.seeInformationGeocerca || role?.geofencesPage.editGeocerca}
              informationOptionMenu={role?.geofencesPage.seeInformationGeocerca}
              editOptionMenu={role?.geofencesPage.editGeocerca}
              exportsPdf={false}
              exportsCsv={false}
              actionDelete={role?.geofencesPage.removeGeocercas}
              showMenu={showModal}
              getFence={getFence}
              searchs={['name', 'description', 'type', 'place', 'date_order']}
              columns={[
                {
                  field: 'name',
                  header: t('headers.one')
                },
                {
                  field: 'description',
                  header: t('headers.two')
                },
                {
                  field: 'type',
                  header: t('headers.three')
                },
                {
                  field: 'place',
                  header: t('headers.four')
                },
                {
                  field: 'date_order',
                  header: t('headers.five')
                }
              ]}
            />}
          </div>
        </section>

        {/* Modal para crear geofences */}
        <ModalFence
          title={t('modalFence.title1')}
          show={modals.create}
          onClose={closeModal}
          onClick={saveFence}
          buttonLabel={t('modalFence.button1')}
          type="add"
          unitArea={unitArea}
          setUnitArea={setUnitArea}
        />

        {/* Modal para editar geofences */}
        <ModalFence
          title={`${t('modalFence.title2')} ${fence?.name}`}
          show={modals.edit}
          onClose={closeModal}
          onClick={saveFence}
          buttonLabel={t('modalFence.button2')}
          type="edit"
          data={fence}
          unitArea={unitArea}
          setUnitArea={setUnitArea}
        />

        {/* Modal para ver la información de una Fence */}
        <ModalInformationFence
          show={modals.information}
          title={`${t('modalInformationFence.title')} ${fence?.name}`}
          onClose={closeModal}
          fence={fence}
        />
      </div>
    </div>
  )
}
